import React, {
    useCallback, useState,
} from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import useResize
    from 'app/PoC/DataGridDemoPages/components/SkyNetResizablePanel/hooks/useResize'
import useStyles
    from 'app/PoC/DataGridDemoPages/components/SkyNetResizablePanel/SkyNetResizablePanel.styles'

type Props = {
    children: React.ReactNode
    initialWidthPercent?: number
    minWidthPercent?: number
    maxWidthPercent?: number
    onWidthChange: (width: number) => void
}
const defaultProps: Partial<Props> = {
    initialWidthPercent: 20,
    minWidthPercent: 20,
    maxWidthPercent: 60,
}

const SkyNetResizablePanel = ({
    children,
    initialWidthPercent,
    minWidthPercent,
    maxWidthPercent,
    onWidthChange,
}: Readonly<Props>) => {
    const [
        isCollapsed,
        setIsCollapsed,
    ] = useState<boolean>(false)

    const {
        classes,
    } = useStyles({
        isCollapsed,
    })

    const {
        containerRef,
        isResizing,
        panelWidth,
        handleResize,
    } = useResize({
        initialWidthPercent,
        minWidthPercent,
        maxWidthPercent,
        onWidthChange,
    })

    const toggleCollapse = useCallback((e: React.MouseEvent) => {
        e.stopPropagation()
        setIsCollapsed(!isCollapsed)
    }, [isCollapsed])

    return (
        <>
            <Box
                ref={containerRef}
                className={classes.childrenWrapper}
                sx={{
                    width: isCollapsed ? '0px' : `${panelWidth}%`,
                    transition: isResizing ? 'none' : 'width 0.3s ease',
                    minWidth: isCollapsed ? '0px' : `${panelWidth}%`,
                }}
            >
                {children}
            </Box>

            <Box
                className={classes.resizeGrabContainer}
                onMouseDown={handleResize}
            >
                <IconButton
                    onClick={toggleCollapse}
                    className={classes.collapseToggle}
                >
                    {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            </Box>
        </>
    )
}

SkyNetResizablePanel.defaultProps = defaultProps

export default SkyNetResizablePanel
